// @ts-strict-ignore
import {AnyAttrs, AttrsSchema, Component} from 'panel';

import {getReportUrl} from 'common/report/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {ReportName} from 'common/report/constants';
import 'common/components/tag';
import {IronContextRegistry} from 'common/report/context-registry';

import {NavReport, NavReports} from '../types';
import {NavigationTrackingEvent} from './tracking';
import {template} from './template';

interface ReportsMenuParams {
  reports: NavReports;
}

export class ReportsMenu extends Component<
  EmptyObj,
  AnyAttrs,
  unknown,
  unknown,
  IronContextRegistry,
  ReportsMenuParams
> {
  static get attrsSchema(): AttrsSchema<AnyAttrs> {
    return {
      ...super.attrsSchema,
      'current-report-name': `string`,
      open: `boolean`,
      order: `json`,
      'project-id': `number`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      template,
      contexts: [`i18n` as const],
      params: {
        reports: Object,
      },
      helpers: {
        getReportUrl,
        ReportName,

        getReports: () => this.attr(`order`).map((r) => this.params.reports[r]),

        getClassSuffix: (report: NavReport) => {
          // make sure to just use 'messages' from 'triggers/messages' and similar urls
          return (report.endpoint || ``).split(`/`).slice(-1)[0];
        },

        handleDropMenuChange: (ev) => {
          ev.stopImmediatePropagation();
          if (ev.detail.state === `closed`) {
            this.setAttribute(`open`, `false`);
            this.dispatchEvent(new CustomEvent(`closemenu`));
          }
        },

        handleClickReportName: (ev, report) => {
          if (report.disabled) {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            return;
          }

          mixpanel.track(NavigationTrackingEvent.SelectReport, {
            'Nav Source': `Menu Nav`,
            'Report From': this.attr(`current-report-name`),
            'Report To': report.name,
          });
        },
      },
    };
  }
}

export const ReportsMenuEl = defineAndMakeJsxFactory(`mp-reports-menu`, ReportsMenu);
export const ReportsMenuReact = panel2react(`mp-reports-menu`, ReportsMenu);
